import React from 'react';

export type FmTopBarMeasuredStyle = React.CSSProperties & {
  '--app-shell-overlay-safe-top'?: string;
};

export const FmTopBarMeasuredHeightContext = React.createContext<string | undefined>(undefined);

/** Carries the owning bar's measured height through React portals. */
export function useFmTopBarMeasuredStyle(): FmTopBarMeasuredStyle | undefined {
  const measuredHeight = React.useContext(FmTopBarMeasuredHeightContext);
  return measuredHeight ? { '--app-shell-overlay-safe-top': measuredHeight } : undefined;
}
